import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import React, { useState } from "react";
import localeText from "../../../../locale";
import { Dropdown } from "primereact/dropdown";
import { locale } from "../../../../utilities/locale/locale";
import { use } from "react";
import { set } from "@cloudinary/url-gen/actions/variable";
import { useLocation } from "react-router-dom";

const CategoryTemplate = (category) => {
  const languages = {
    en: "descriptionEnglish",
    it: "descriptionItalian",
    pt: "descriptionPortuguese",
    es: "descriptionSpanish",
  };
  const language = languages[locale];

  return (
    <div className="flex align-items-center">
      <div className="text-sm">{category[language]}</div>
    </div>
  );
};

const SelectedCategoryTemplate = (option, props) => {
  const languages = {
    en: "descriptionEnglish",
    it: "descriptionItalian",
    pt: "descriptionPortuguese",
    es: "descriptionSpanish",
  };
  const language = languages[locale] ?? "";
  if (option) {
    return (
      <div className="flex align-items-center h-full">
        <div className="text-sm">{option[language]}</div>
      </div>
    );
  }
  return (
    <div className="flex align-items-center h-full">
      <div className="text-sm">{localeText("all")}</div>
    </div>
  );
};
const SearchInput = ({
  setExpression,
  expression,
  category,
  setCategory,
  onSearch,
  isLoading,
  categories,
  handleSelectedCategory,
  selectedCategory,
  loadingCategories,
}) => {
  const isDisabled = loadingCategories ? "opacity-80 pointer-events-none" : "";

  const setSelectdCategory = (e) => {
    setCategory(e.value);
  };

  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  return (
    <div
      className="grid grid-nogutter md:col col-12 mt-3 md:px-4 md:mt-0 flex-order-1 md:flex-order-0"
      style={{ flexWrap: "nowrap", height: "40px" }}
    >
      {!isFringeBenefitsPage && (
        <Dropdown
          className={`${isDisabled} border-round-left-md border-noround-right p-no-outline border-none px-2 hidden md:inline-flex`}
          style={{ backgroundColor: "#EBECF0" }}
          onChange={setSelectdCategory}
          value={category}
          filter
          /* optionLabel="title" */
          placeholder={localeText("selectStore")}
          options={categories}
          itemTemplate={CategoryTemplate}
          valueTemplate={SelectedCategoryTemplate}
        />
      )}

      <InputText
        value={expression}
        onChange={(e) => setExpression(e.target.value)}
        placeholder={localeText("searchProducts")}
        className={`font-medium text-sm border-none md:border-left-2 md:border-left-0 col border-noround-right md:border-noround p-no-outline px-3 w-full ${
          isFringeBenefitsPage ? "border-round-left-md" : ""
        }`}
        onKeyDown={(e) => {
          if (e.key === "Enter") onSearch(expression, isFringeBenefitsPage ? { id: -1 } : category);
        }}
      ></InputText>
      <Button
        className="text-white border-noround-left border-round-right-md"
        style={{ backgroundColor: "#2E4E5C", minWidth: "3rem" }}
        icon={<i className="pi pi-search"></i>}
        text
        onClick={() => onSearch(expression, category)}
        loading={isLoading}
      />
    </div>
  );
};

export default SearchInput;
